import { findAllWeavingAlertWithQuantities } from "../../_services/weaving_alert"

export const findAllWeavingAlertWithQuantitiesEvent = async () => {
    const res = await findAllWeavingAlertWithQuantities();
    if(!res.ok) throw new Error(res.error);

    return res;
}